    // // Function to add image to a radio button label
    // function addImageToRadioButton(radioId, imageUrl) {
    //     const radioLabel = document.querySelector(`label[for="${radioId}"]`);
    //     if (radioLabel) {
    //         radioLabel.style.backgroundImage = `url('${imageUrl}')`;
    //         // You can customize additional styles or properties here
    //     } else {
    //         console.error(`Radio button label for ID '${radioId}' not found.`);
    //     }
    // }

    // // Add images to radio buttons (replace URLs and IDs accordingly)
    // addImageToRadioButton('val818895041357100', 'https://cdn.shopify.com/s/files/1/0670/7347/4819/files/nursery_pot__black_resize.png?v=1701951663');
    // addImageToRadioButton('radio2', 'https://example.com/image2.jpg');
    // addImageToRadioButton('radio3', 'https://example.com/image3.jpg');


document.addEventListener("DOMContentLoaded", function() {
    // Your JavaScript code here

    function addImageToRadioButton(radioId, imageUrl) {
        const radioLabel = document.querySelector(`label[for="${radioId}"]`);
        if (radioLabel) {
            radioLabel.style.backgroundImage = `url('${imageUrl}')`;
            // You can customize additional styles or properties here
        } else {
            console.error(`Radio button label for ID '${radioId}' not found.`);
        }
    }

    // Add images to radio buttons (replace URLs and IDs accordingly)
    addImageToRadioButton('val818895041357100', 'https://cdn.shopify.com/s/files/1/0670/7347/4819/files/nursery_pot__black_resize.png?v=1701951663');
});